module.exports = __webpack_public_path__ + "img/xmark.3386270a.jpeg";